import { SET_BANNER,SET_BANNER_LASTUPDDT } from "../constant";

const BannerReducer = (state = {}, action) => {
    switch (action.type) {
        case SET_BANNER:
            return {
                ...state,
                data: action.data
            }
        case SET_BANNER_LASTUPDDT:
                return {
                    ...state,
                lastUpdDt: action.data
            }    
        default:
            return state
    }
}

export default BannerReducer
